import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=589003be&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=589003be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589003be",
  null
  
)

export default component.exports